module.exports = __webpack_public_path__ + "static/media/react-native.aff974b5.png";